import { debounce } from "../utils/performance";

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.01,
};

let wasAudioMuted = true;
let wasPLaying = true;

const videoPlayToggle = (toggleEl, video) => {
  if (toggleEl.dataset.state === 'playing') {
    video.pause();
    toggleEl.dataset.state = "paused";
  } else {
    video.play();
    toggleEl.dataset.state = "playing";
  }
}

const videoMuteToggle = (toggleEl, video) => {
  if (toggleEl.dataset.state === 'muted') {
    video.muted = false;
    video.volume = 1;
    toggleEl.dataset.state = "unmuted";
  } else {
    video.muted = true;
    video.volume = 0;
    toggleEl.dataset.state = "muted";
  }
}

const addBgVideoTogglers = function () {
  const videos = document.querySelectorAll('.embededVideo');
  if (!videos) return;

  videos.forEach((video) => {
    const sectionWrapper = video.closest('.section-wrapper');
    const playToggleEL = sectionWrapper?.querySelector('.ButtonGroup--playToggle');
    const muteToggleEL = sectionWrapper?.querySelector('.ButtonGroup--muteToggle');
    if (!playToggleEL) return;

    const observer = new IntersectionObserver((e) => {
      if (!e[0].isIntersecting) {
        wasPLaying = !video.paused;
        wasAudioMuted = video.muted;

        video.pause();
        playToggleEL.dataset.state = "paused";
        return;
      };

      video.muted = wasAudioMuted;
      if (!wasPLaying) return;

      video.play();
      playToggleEL.dataset.state = "playing";
    }, options);
    
    playToggleEL.addEventListener('click', () => videoPlayToggle(playToggleEL, video));
    muteToggleEL.addEventListener('click', () => videoMuteToggle(muteToggleEL, video));

    observer.observe(video);
  });
};

const videoSourceSetter = function () {
  if (!window.BackgroundVideoSetting) return;
  Object.entries(window.BackgroundVideoSetting).forEach(([k, v]) => {
    const isMobile = window.matchMedia('(max-width: 750px)').matches;
    const video = document.querySelector(`#shopify-section-${k} video`) || document.querySelector(`#${k} video`);
    if (!video) return; 

    const mobileVideo = v.mobile;
    const desktopVideo = v.desktop;
    if ((isMobile && video.src !== mobileVideo) || (!isMobile && video.src !== desktopVideo)) {
      video.src = isMobile ? mobileVideo : desktopVideo;
      video.load(); 
    }
  });
};

const handleSectionClick = () => {
  const sections = document.querySelectorAll('[data-section-link]');
  
  sections.forEach((section) => {
    section.addEventListener('click', () => {
      window.location.href = section.dataset.sectionLink;
    });
  });
};

export default () => {
  handleSectionClick();
  videoSourceSetter();
  addBgVideoTogglers();
  window.addEventListener('resize', debounce(videoSourceSetter, 250));
};
